'use strict';

(function($) {
    $(function() {

        $('.select-box__item').click(function() {
            $(this).parents('.select-box').find('.select-box__item').removeClass('is-selected');
            $(this).addClass('is-selected');

            $(this).parents('.select-box').find('input').attr('checked',false);
            $('input',this).attr('checked',true);
        });

    });
})(jQuery);
